'use client';

import '@ui5/webcomponents/dist/Label.js';
import { withWebComponent } from '../../internal/withWebComponent.js';
/**
 * The `Label` is a component used to represent a label for elements like input, textarea, select.
 *
 * The `for` property of the `Label` must be the same as the id attribute of the related input element.
 *
 * Screen readers read out the label, when the user focuses the labelled control.
 *
 * The `Label` appearance can be influenced by properties, such as `required` and `wrappingType`. The appearance of the Label can be configured in a limited way by using the design property. For a broader choice of designs, you can use custom styles.
 *
 * __Note:__ This component is a web component developed by the UI5 Web Components’ team.
 *
 * [UI5 Web Components Storybook](https://sap.github.io/ui5-webcomponents/playground/?path=/docs/main-Label)
 */
const Label = withWebComponent('ui5-label', ['for', 'wrappingType'], ['required', 'showColon'], [], []);
Label.displayName = 'Label';
export { Label };